module.exports = __webpack_public_path__ + "static/media/socomore.d914e587.png";